import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Components
import Accordion from 'components/Accordion';
import WaiverForm from './WaiverForm';

type Props = {
  defaultExpanded?: boolean;
}

const Waiver:FC<Props> = ({ defaultExpanded }) => {
  const { t } = useTranslation();

  return (
    <div className="w-full" react-scroll="waiver">
      <Accordion label={t('pages.quizForm.waiverLabel')} icon="checkmark" previewPage="waiver" defaultExpanded={defaultExpanded}>
        <WaiverForm />
      </Accordion>
    </div>
  )
}

export default Waiver;
